import { BookingService } from 'src/app/services/booking.service';
import { CommonService } from './../../../services/common.service';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { HomeService } from '../../../services/home.service';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { VehicleReservationsPopularDealsModel } from 'src/app/models/Common/VehicleReservationsPopularDealsModel';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/services/search.service';
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { NotificationsService } from 'angular2-notifications';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RentalVehicleNotAvailableComponent } from '../../booking/rental-vehicle-not-available/rental-vehicle-not-available.component';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { LoadingService } from 'src/app/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'popular-cars',
  templateUrl: './popular-cars.component.html',
  styleUrls: ['./popular-cars.component.css']
})
export class PopularCarsComponent implements OnInit {

  popularCars;
  searchType: VehicleSearchTypeEnum;
  currentLocation: { lat: number; lng: number; };
  hideDeals = false;
  searchForm: FormGroup;
  @Input() gracePeriodInHours;

  listener;
  statisticDivYPosition;
  @ViewChild('statisticDiv', { static: true }) statisticDiv: ElementRef;




  @HostListener("window:scroll", []) onWindowScroll() {
    // do some stuff here when the window is scrolled
    const verticalOffset = window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop || 0;

    if (verticalOffset + 200 >= this.statisticDivYPosition) {
      if (this.popularCars == null) {
        this.commonService.getVehicleReservationsPopularDealsStatistics().subscribe(res => {

          this.searchType = res.searchAvailableVehicleFilterType;
          this.popularCars = res.result;

          if (this.popularCars == null) {
            this.hideDeals = true;
          }

        })
      }
    }
  }


  constructor(service: HomeService,
    private commonService: CommonService,
    private router: Router,
    private searchService: SearchService,
    private notificationService: NotificationsService,
    private attachmentService: AttachmentService,
    private dialog: MatDialog,
    private bookingService: BookingService,
    private _dateFormatPipe: DateFormatPipe,
    private loaderService: LoadingService,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
  ) {
    //this.popularCars = service.getPopularCars();
  }
  ngOnInit(): void {
    this.statisticDivYPosition = this.statisticDiv.nativeElement.getBoundingClientRect().y;
    const today = new Date()
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    this.searchForm = this.formBuilder.group({

      PickUpDate: [today],
      dropUpDate: [tomorrow],
    });
  }
  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }

  getYPosition(e: Event): number {
    let x = (e.target as Element);

    return (e.target as Element).scrollTop;
  }

  popularCarsLocker = false;
  readMore(popularCar: VehicleReservationsPopularDealsModel) {
    if (this.popularCarsLocker) {
      return;
    }
    this.showLoader();
    this.popularCarsLocker = true;
    navigator.geolocation.getCurrentPosition(position => {

      this.searchService.geocode(position.coords.latitude, position.coords.longitude)
        .subscribe(res => {


          let locatons = JSON.parse(JSON.stringify(res));
          let formatedLocation = locatons.results[0].formatted_address;
          this.onEnd();
          let latitude = null;
          let longitude = null;
          if (position != null) {

            latitude = position.coords.latitude;
            longitude = position.coords.longitude;

            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 1)

            let minTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriodInHours); //For the Place holder in html


            var searchModel: VehicleReservationSearchParm = {
              Latitude: latitude,
              Longitude: longitude,
              StartDate:this.searchForm.value['PickUpDate'],
              StartDateString: this._dateFormatPipe.transform(today),
              StartTimeString: minTime,
              EndDateString: this._dateFormatPipe.transform(tomorrow),
              EndDate:this.searchForm.value['dropUpDate'],
              EndTimeString: minTime,
              FormatedLocation: formatedLocation,
              FromPopularCars:true
            }
            searchModel.ClassID = popularCar.classID;
            searchModel.MakeID = popularCar.makeID;
            searchModel.ModelID = popularCar.modelID;
            searchModel.Year = popularCar.year;
            /*     if (this.searchType == VehicleSearchTypeEnum.classSearch) {
                  searchModel.ClassID = popularCar.classID;
                }
                else if (this.searchType == VehicleSearchTypeEnum.MakeModelYearSearch) {
                  searchModel.MakeID = popularCar.makeID;
                  searchModel.ModelID = popularCar.modelID;
                  searchModel.Year = popularCar.year;
                }
                else {
                  searchModel.ClassID = popularCar.classID;
                  searchModel.MakeID = popularCar.makeID;
                  searchModel.ModelID = popularCar.modelID;
                  searchModel.Year = popularCar.year;
                } */
            this.searchService.updateSearchModel(searchModel);
            //this.router.navigate(['/searchByLocation', { search: JSON.stringify(searchModel) }]);
            this.popularCarsLocker = false;
            this.router.navigate(['/searchByLocation']);

          }
          else {
            this.translate.get(['Yourlocationisdisabled', 'topdealsdependsonyourlocationpleaseenableittocontinue',]).subscribe(res => {
              this.notificationService.warn("<span>" + res.Yourlocationisdisabled + "</span><br />" + res.topdealsdependsonyourlocationpleaseenableittocontinue, null, {
                timeOut: 30000,
                showProgressBar: false,
                pauseOnHover: true,
                clickToClose: true,
                fade: true,
                actions: [{
                  action: "Allow",
                }],
                icons: {
                  error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
                  warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
                }
              });
            })

            this.popularCarsLocker = false;
          }
        });


    },
      err => {
        this.onEnd();
        if (err.code == 1) {
          this.translate.get(['Yourlocationisdisabled', 'topdealsdependsonyourlocationpleaseenableittocontinue',]).subscribe(res => {
            this.notificationService.warn("<span>" + res.Yourlocationisdisabled + "</span><br />" + res.topdealsdependsonyourlocationpleaseenableittocontinue, null, {
              timeOut: 30000,
              showProgressBar: false,
              pauseOnHover: true,
              clickToClose: true,
              fade: true,
              actions: [{
                action: "Allow",
              }],
              icons: {
                error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
                warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
              }
            });
          })

        }
        this.popularCarsLocker = false;

      }

    );

  }

  RentalVehicleNotAvailable() {

    const dialogConfig = new MatDialogConfig();
    this.dialog.open(RentalVehicleNotAvailableComponent, dialogConfig);
  }

  private onEnd(): void {
    this.hideLoader();
  }
  private showLoader(): void {
    this.loaderService.show();


  }
  private hideLoader(): void {
    this.loaderService.hide();
  }


}
